var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeCancellation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3034_1012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3034_1012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 23.5751L12.85 19.4251L14.5 17.7751L16.975 20.2501L21.575 15.6251L23.225 17.3251L17 23.5751ZM7.925 17.9001L6.275 16.2501L8.05 14.4751L6.275 12.7001L7.925 11.0501L9.7 12.8251L11.475 11.0501L13.125 12.7001L11.35 14.4751L13.125 16.2501L11.475 17.9001L9.7 16.1251L7.925 17.9001ZM2.375 22.6251V2.8501H6.13V1.3501H8.175V2.8501H15.825V1.3501H17.88V2.8501H21.65V13.4501L19.275 15.8501V9.7501H4.725V20.2751H11.55L13.9 22.6251H2.375ZM4.725 8.2501H19.275V5.2251H4.725V8.2501Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeCancellation1);
export default __webpack_public_path__ + "static/media/free_cancellation (1).fc6d354b1d21dfad8eee096b5ccc7762.svg";
export { ForwardRef as ReactComponent };